/**
 * viho-mob-rotator.js
 * 1. Rotates .viho-mob-feat--slide cards inside [data-viho-mob-rotator].
 *    Starts at a random index so each page load feels fresh.
 *    Interval: 3.5 seconds.
 *
 * 2. Hides Horizon's sticky-add-to-cart bar when the nav drawer is open.
 *    Horizon JS sets display:flex via inline style, which beats CSS !important
 *    from a stylesheet. We match it with setProperty(..., 'important') so our
 *    inline override wins, then remove it when the drawer closes.
 */
(function () {

  /* ── 1. Featured card rotator ─────────────────────────────────────────── */
  function initRotators() {
    document.querySelectorAll('[data-viho-mob-rotator]').forEach(function (rotator) {
      if (rotator.dataset.vihoRotatorInited) return;
      rotator.dataset.vihoRotatorInited = '1';
      var slides = Array.from(rotator.querySelectorAll('.viho-mob-feat--slide'));
      if (slides.length <= 1) {
        if (slides.length === 1) slides[0].classList.add('is-active');
        return;
      }

      var current = Math.floor(Math.random() * slides.length);

      // Show initial slide — opacity transition handles smoothness, no rAF needed
      slides[current].classList.add('is-active');

      setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, 3500);
    });
  }

  /* ── 2. Sticky ATC bar hide when nav drawer is open ──────────────────── */
  function initStickyAtcGuard() {
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (!drawer) return;

    function getStickyBar() {
      return document.querySelector('sticky-add-to-cart, .sticky-add-to-cart');
    }

    function syncStickyBar() {
      var bar = getStickyBar();
      if (!bar) return;
      if (drawer.classList.contains('menu-open') || drawer.open) {
        /* Force-hide: inline !important beats any JS-applied inline style */
        bar.style.setProperty('display', 'none', 'important');
        bar.style.setProperty('visibility', 'hidden', 'important');
        bar.setAttribute('data-viho-hidden', '1');
      } else if (bar.getAttribute('data-viho-hidden') === '1') {
        bar.style.removeProperty('display');
        bar.style.removeProperty('visibility');
        bar.removeAttribute('data-viho-hidden');
      }
    }

    /* Watch for class and open-attribute changes on the drawer details element */
    var observer = new MutationObserver(syncStickyBar);
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'open']
    });

    /* Run once on load in case the drawer is already open */
    syncStickyBar();
  }

  /* ── 3. Find Your Flavor dropdown — category filter ─────────────────── */
  function initFlavorDropdowns() {
    document.querySelectorAll('[data-viho-ffdd]').forEach(function (ffdd) {
      var cats   = ffdd.querySelectorAll('[data-viho-ffdd-cats] .viho-ffdd__cat');
      var chips  = ffdd.querySelectorAll('[data-viho-ffdd-chips] .viho-ffdd__card');
      var title  = ffdd.querySelector('[data-viho-ffdd-title]');
      var viewAll = ffdd.querySelector('[data-viho-ffdd-viewall]');

      cats.forEach(function (cat) {
        cat.addEventListener('mouseenter', function () {
          /* Activate tab */
          cats.forEach(function (c) { c.classList.remove('is-active'); });
          cat.classList.add('is-active');

          var kw = (cat.dataset.kw || 'all').split(',').map(function (k) { return k.trim(); });
          var all = kw[0] === 'all';
          var visible = 0;

          chips.forEach(function (chip) {
            var t = chip.dataset.title || '';
            var show = all || kw.some(function (k) { return t.indexOf(k) > -1; });
            chip.toggleAttribute('hidden', !show);
            if (show) visible++;
          });

          /* Update header */
          var catName = cat.querySelector('.viho-ffdd__cat-name');
          if (title) title.textContent = catName ? catName.textContent : (all ? 'All Flavors' : 'Matching Flavors');
          if (viewAll && cat.dataset.href) viewAll.href = cat.dataset.href;

          /* Update count badge */
          var badge = cat.querySelector('.viho-ffdd__cat-badge');
          if (badge && !all) badge.textContent = visible;
        });
      });
    });
  }



  /* ── 4. In Stock Now series panel switcher ──────────────────────────── */
  function initSeriesPanels() {
    /* Check overflow on the default-active series panel on load */
    document.querySelectorAll('.viho-mega__series-panel.is-active').forEach(function (p) {
      checkSeriesPanelOverflow(p);
    });

    /* TRX 50K flat panels: re-check overflow when the mega first opens.
       The inline checkItemOverflow runs at DOMContentLoaded when the dropdown
       is display:none, giving scrollWidth=0. Re-check on first hover when
       the panel is actually visible so long names get the marquee class.    */
    document.querySelectorAll('.menu-list__item').forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        var mega = li.querySelector('[data-viho-mega]');
        if (!mega) return;
        requestAnimationFrame(function () {
          mega.querySelectorAll('.viho-mega__panel.is-active .viho-mega__item-text').forEach(function (textEl) {
            if (textEl.scrollWidth > textEl.offsetWidth + 4) {
              textEl.classList.add('viho-mega__item-text--overflow');
              /* Set scroll distance for the CSS animation */
              var inner = textEl.querySelector('.viho-mega__item-text-inner');
              if (inner) {
                var dist = -(textEl.scrollWidth - textEl.offsetWidth + 4);
                textEl.closest('.viho-mega__item-link') &&
                  textEl.closest('.viho-mega__item-link').style.setProperty('--viho-scroll', dist + 'px');
              }
            }
          });
        });
      }, { once: true });
    });

    /* Also re-check active flat panel when a mega tab is switched */
    document.querySelectorAll('[data-viho-tab]').forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        var mega = tab.closest('[data-viho-mega]');
        if (!mega) return;
        var idx = tab.dataset.vihoTab;
        setTimeout(function () {
          var panel = mega.querySelector('[data-viho-panel="' + idx + '"]');
          if (!panel) return;
          panel.querySelectorAll('.viho-mega__item-text').forEach(function (textEl) {
            if (textEl.scrollWidth > textEl.offsetWidth + 4) {
              textEl.classList.add('viho-mega__item-text--overflow');
              var link = textEl.closest('.viho-mega__item-link');
              if (link) link.style.setProperty('--viho-scroll', -(textEl.scrollWidth - textEl.offsetWidth + 4) + 'px');
            }
          });
          panel.querySelectorAll('.viho-mega__series-panel').forEach(function (sp) {
            checkSeriesPanelOverflow(sp);
          });
        }, 60);
      });
    });

    document.querySelectorAll('.viho-mega__series-tab').forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        var wrap = tab.closest('.viho-mega__series-wrap');
        if (!wrap) return;
        wrap.querySelectorAll('.viho-mega__series-tab').forEach(function (t) {
          t.classList.remove('is-active');
        });
        tab.classList.add('is-active');
        var idx = tab.dataset.seriesTab;
        wrap.querySelectorAll('.viho-mega__series-panel').forEach(function (p) {
          p.classList.remove('is-active');
        });
        var panel = wrap.querySelector('[data-series-panel="' + idx + '"]');
        if (panel) {
          panel.classList.add('is-active');
          checkSeriesPanelOverflow(panel);
        }
      });
    });

    /* Also check overflow when the mega tab for "In Stock Now" first opens */
    document.querySelectorAll('[data-viho-tab]').forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        var idx = tab.dataset.vihoTab;
        var mega = tab.closest('[data-viho-mega]');
        if (!mega) return;
        var panel = mega.querySelector('[data-viho-panel="' + idx + '"]');
        if (panel) {
          /* Small delay ensures the panel is visible before measuring */
          setTimeout(function () {
            panel.querySelectorAll('.viho-mega__series-panel').forEach(function (sp) {
              checkSeriesPanelOverflow(sp);
            });
          }, 60);
        }
      });
    });
  }


  /* ── Account + Cart hover: pure JS so no CSS specificity battles ──────── */
  function initHeaderIconHover() {
    var accountDiv = document.querySelector('.header-actions__action');
    var cartEl     = document.querySelector('cart-icon, .header-actions__cart-icon');
    var acctIcon   = document.querySelector('.account-button__icon');
    var cartSvg    = cartEl ? cartEl.querySelector('svg') : null;

    if (!accountDiv || !cartEl) return;

    /* Set colors explicitly via inline style (beats all CSS specificity) */
    function setColor(el, color) { if (el) el.style.setProperty('color', color, 'important'); }
    function resetBoth()  { setColor(acctIcon, '#1d1d1f'); setColor(cartSvg, '#1d1d1f'); }

    accountDiv.addEventListener('mouseenter', function () {
      setColor(acctIcon, '#1E73FF');
      setColor(cartSvg,  '#1d1d1f');
    });
    accountDiv.addEventListener('mouseleave', resetBoth);

    cartEl.addEventListener('mouseenter', function () {
      setColor(cartSvg,  '#1E73FF');
      setColor(acctIcon, '#1d1d1f');
    });
    cartEl.addEventListener('mouseleave', resetBoth);

    /* Set initial dark state */
    resetBoth();
  }

  /* ── 6. Flavor-card marquee: measure on first visible hover ─────────── */
  function measureCardMarquee(ffdd) {
    ffdd.querySelectorAll('.viho-ffdd__card').forEach(function (card) {
      /* Skip only if already successfully measured (overflow confirmed & set) */
      if (card.hasAttribute('data-name-overflow')) return;
      var name = card.querySelector('.viho-ffdd__card-name');
      if (!name) return;
      var overflow = name.scrollWidth - name.offsetWidth;
      if (overflow > 3) {
        card.setAttribute('data-name-overflow', '1');
        card.style.setProperty('--viho-card-scroll', (-overflow - 4) + 'px');
      }
    });
  }

  function initFlavorCardMarquee() {
    document.querySelectorAll('[data-viho-ffdd]').forEach(function (ffdd) {
      var navLi = ffdd.closest('.menu-list__item') || ffdd.closest('li');
      function onOpen() {
        /* Double rAF: guarantees the dropdown CSS transition has completed
           and the browser has laid out the cards at their real dimensions
           before we read scrollWidth.  150ms timeout was unreliable —
           dropdown still hidden → scrollWidth = 0 → card never flagged.    */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            measureCardMarquee(ffdd);
          });
        });
      }
      if (navLi) navLi.addEventListener('mouseenter', onOpen);
    });
  }

  /* ── 7. Series panel overflow — fires AFTER display:block so dims are real ── */
  function checkSeriesPanelOverflow(panel) {
    if (!panel) return;
    /* requestAnimationFrame ensures the browser has painted the newly-visible
       panel before we read scrollWidth — fixes the zero-dimensions bug.      */
    requestAnimationFrame(function () {
      panel.querySelectorAll('.viho-mega__item-text').forEach(function (textEl) {
        var overflow = textEl.scrollWidth > textEl.offsetWidth + 4;
        textEl.classList.toggle('viho-mega__item-text--overflow', overflow);
      });
    });
  }

  /* ── Drawer fixes ─────────────────────────────────────────────────────────
     Applies at ALL viewport widths where the drawer exists.
     CSS (4-class flexbox rule) handles × placement; JS reinforces via inline
     setProperty so Horizon hydration cannot override us. After any DOM change
     inside the drawer we re-run the fix automatically.

     Search icon: CSS handles icon-only display in left column (no JS move).
     1. Sub-drawer × → RIGHT side via flexbox (position:relative, margin-left:auto).
     2. Main drawer × → hidden when sub-drawer is open (MutationObserver).
     3. Sub-drawer × → hidden when any child panel is open.
  ─────────────────────────────────────────────────────────────────────────── */
  function initIPadDrawerFixes() {

    /* ── Fix nav-buttons × via flexbox (matches 4-class CSS rule) ─────────── */
    function fixNavBtnX(navButtons) {
      var x       = navButtons.querySelector('.menu-drawer__close-button, .close-button');
      var backBtn = navButtons.querySelector('.menu-drawer__back-button');
      if (!x) return;

      /* Nav-buttons: explicit flex container with fixed height */
      navButtons.style.setProperty('display',      'flex',   'important');
      navButtons.style.setProperty('align-items',  'center', 'important');
      navButtons.style.setProperty('height',       '56px',   'important');
      navButtons.style.setProperty('padding',      '0',      'important');
      navButtons.style.setProperty('overflow',     'hidden', 'important');

      /* Back button: flex:1 takes all remaining left-side space */
      if (backBtn) {
        backBtn.style.setProperty('flex',        '1',    'important');
        backBtn.style.setProperty('width',       'auto', 'important');
        backBtn.style.setProperty('margin-left', '16px', 'important');
      }

      /* × button: flex item pushed to the RIGHT — NOT position:absolute */
      x.style.setProperty('position',        'relative', 'important');
      x.style.setProperty('left',            'auto',     'important');
      x.style.setProperty('top',             'auto',     'important');
      x.style.setProperty('transform',       'none',     'important');
      x.style.setProperty('margin-left',     'auto',     'important');
      x.style.setProperty('margin-right',    '16px',     'important');
      x.style.setProperty('width',           '24px',     'important');
      x.style.setProperty('height',          '24px',     'important');
      x.style.setProperty('flex-shrink',     '0',        'important');
      x.style.setProperty('border-radius',   '50%',      'important');
      x.style.setProperty('background',      '#f2f2f7',  'important');
      x.style.setProperty('display',         'flex',     'important');
      x.style.setProperty('align-items',     'center',   'important');
      x.style.setProperty('justify-content', 'center',   'important');
    }

    /* Apply immediately */
    document.querySelectorAll('.menu-drawer__nav-buttons').forEach(fixNavBtnX);

    /* Re-apply if Horizon hydrates and replaces the drawer DOM */
    var drawerRoot = document.querySelector('header-drawer') ||
                     document.querySelector('.header__drawer');
    if (drawerRoot) {
      new MutationObserver(function (mutations) {
        if (mutations.some(function (m) { return m.addedNodes.length > 0; })) {
          document.querySelectorAll('.menu-drawer__nav-buttons').forEach(fixNavBtnX);
        }
      }).observe(drawerRoot, { childList: true, subtree: true });
    }

    /* ── Main drawer × → opacity:0 when sub-drawer opens ─────────────────── */
    var menuDrawer = document.querySelector('.menu-drawer');
    var mainX      = menuDrawer
                     ? menuDrawer.querySelector(':scope > .menu-drawer__close-button')
                     : null;
    if (menuDrawer && mainX) {
      function syncMainX() {
        var open = menuDrawer.classList.contains('menu-drawer--has-submenu-opened');
        mainX.style.setProperty('opacity',        open ? '0' : '', 'important');
        mainX.style.setProperty('pointer-events', open ? 'none' : '', 'important');
      }
      new MutationObserver(syncMainX)
        .observe(menuDrawer, { attributes: true, attributeFilter: ['class'] });
      syncMainX();
    }

    /* ── Sub-drawer × → hidden when child panel opens ─────────────────────── */
    document.querySelectorAll('.menu-drawer__submenu').forEach(function (sub) {
      var navBtns = sub.querySelector('.menu-drawer__nav-buttons');
      var subX    = navBtns
                    ? (navBtns.querySelector('.menu-drawer__close-button') ||
                       navBtns.querySelector('.close-button'))
                    : null;
      if (!subX) return;

      function syncSubX() {
        var childOpen = !!sub.querySelector('.viho-child-drawer[open]');
        subX.style.setProperty('opacity',        childOpen ? '0' : '', 'important');
        subX.style.setProperty('pointer-events', childOpen ? 'none' : '', 'important');
      }
      new MutationObserver(syncSubX)
        .observe(sub, { attributes: true, subtree: true, attributeFilter: ['open'] });
      syncSubX();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRotators();
      initStickyAtcGuard();
      initFlavorDropdowns();
      initSeriesPanels();
      initFlavorCardMarquee();
      initIPadDrawerFixes();
    });
  } else {
    initRotators();
    initStickyAtcGuard();
    initFlavorDropdowns();
    initSeriesPanels();
    initFlavorCardMarquee();
    initIPadDrawerFixes();

  }

})();
